import type { Pagination } from '@pba/react-query';
import { useCallback } from 'react';
import type { FindUsersRequest } from '../../../services';
import type { UsersQueryFilter } from '../useGetUsers';

export const DEFAULT_PAGE_SIZE = 10;

export const useGetUsersParameters = () =>
  useCallback(
    ({
      filter,
      pagination,
      skip,
    }: {
      filter: UsersQueryFilter;
      pagination?: Partial<Pagination>;
      skip?: number;
    }): FindUsersRequest => {
      const pageSize = pagination?.pageSize ?? DEFAULT_PAGE_SIZE;

      return {
        // TODO: test this after backend is updated https://redmine.touch4it.com/issues/88278
        ...(filter.userIds?.length ? { _id: { $in: filter.userIds } } : {}),
        $limit: pageSize,
        $search: filter.search === '' ? undefined : filter.search,
        $skip: skip ?? ((pagination?.position ?? 1) - 1) * pageSize,
      };
    },
    [],
  );
